'use client'

import * as React from 'react'
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/ui/command'
import { ThemesData, useGetThemeMode } from '../lib'
import { SelectPaletteButton } from './select-palette-button'
import { ThemeModeToggle } from './theme-mode-toggle'
import { shortcuts } from '@/shared/shortcuts'
import { useHotkeys } from 'react-hotkeys-hook'

export interface PaletteSetupCommandProps {
  shortcut?: (v: typeof shortcuts) => string
}

export function PaletteSetupCommand({ shortcut, children }: React.PropsWithChildren<PaletteSetupCommandProps>) {
  const [open, setOpen] = React.useState(false)

  const mode = useGetThemeMode()

  useHotkeys(shortcut ? shortcut(shortcuts) : '', () => {
    setOpen((prev) => !prev)
  })

  const renderTrigger = () => {
    if (children)
      return (
        <div onClick={() => setOpen(true)} className="cursor-pointer">
          {children}
        </div>
      )
    else return null
  }

  return (
    <>
      {renderTrigger()}
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Введите команду или выполните поиск..." />
        <CommandList>
          <CommandEmpty>Ничего не найдено.</CommandEmpty>
          <CommandGroup
            heading={
              <div className="w-full flex items-center gap-x-2 justify-between">
                <p>
                  Выберите тему, также вы можете настроить тему для темного и светлого режима, выбрав необходимый режим!
                </p>
                <ThemeModeToggle />
              </div>
            }
          >
            <div className="flex flex-col gap-1">
              {ThemesData.map((item, index) => {
                return (
                  <CommandItem key={index} className="p-0! rounded">
                    <SelectPaletteButton type={mode} theme={item} className="px-4 py-3" />
                  </CommandItem>
                )
              })}
            </div>
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  )
}
